module.exports = __webpack_public_path__ + "static/media/fail.9e8d6c05.mp3";